var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"head"}},[_c('div',{staticClass:"right"},[_c('h4',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"left"},[_vm._t("actions")],2)]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }